import React, { FC, useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useHistory } from 'react-router';
import { Box, Container, Card, CardContent, Link } from '@mui/material';
import { Page } from '@cigam/template/dist/components';
import { useSelector } from 'src/store';
import { LoginForm } from './LoginForm';
import AutenticacaoDoisFatores from './AutenticacaoDoisFatores';
import { DoisFatoresProvider } from '../../../contexts/DoisFatoresContext';
import { LoginDTO } from '../../../types/dtos/auth';

const PREFIX = 'LoginCigam';

const classes = {
  root: `${PREFIX}-root`,
  card: `${PREFIX}-card`,
  image: `${PREFIX}-image`,
  content: `${PREFIX}-content`,
};

const StyledPage = styled(Page)(({ theme }) => ({
  [`&.${classes.root}`]: {
    justifyContent: 'center',
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    minHeight: '100%',
    flexDirection: 'column',
    backgroundImage: 'url(/static/client/background.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundAttachment: 'fixed',
  },

  [`& .${classes.card}`]: {
    overflow: 'visible',
    display: 'flex',
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%',
    },
  },

  [`& .${classes.image}`]: {
    maxWidth: '100%',
    maxHeight: '100%',
  },

  [`& .${classes.content}`]: {
    padding: theme.spacing(3, 4, 3, 4),
  },
}));

const LoginCigam: FC = () => {
  const history = useHistory();
  const { historyNavigation } = useSelector(state => state);
  const [telaAtiva, setTelaAtiva] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState<LoginDTO | null>({
    Codigo: '',
    CpfCnpj: '',
    Email: '',
    Empresa: '',
    LoginUsuario: '',
    NomeEmpresa: '',
    NomeUsuario: '',
  });

  const handleSubmitSuccess = async () => {
    history.push(historyNavigation.pathname);
  };

  const handleDoisFatores = () => {
    const userStorage = localStorage.getItem('user');
    const userData = userStorage ? JSON.parse(userStorage) : '';
    if (
      userData &&
      (userData?.CodigoMensagem === '440' || userData?.CodigoMensagem === '439')
    ) {
      setTelaAtiva(userData?.CodigoMensagem === '440' ? 'codigo' : 'pergunta');
      setOpen(true);
    }
  };

  const contextValue = useMemo(
    () => ({
      username,
      password,
      user,
      setUsername,
      setPassword,
      setUser,
    }),
    [username, password, user, setUsername, setPassword, setUser]
  );

  return (
    <>
      <DoisFatoresProvider value={contextValue}>
        <StyledPage className={classes.root} title="Login">
          <Container maxWidth="xs">
            {!open && (
              <Card className={classes.card}>
                <CardContent className={classes.content}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mb={2}
                  >
                    <img
                      alt="Logo CIGAM"
                      src="/static/client/logo.png"
                      onError={ev => {
                        ev.currentTarget.src = '/static/images/logo-cigam.png';
                      }}
                      className={classes.image}
                    />
                  </Box>
                  <Box mt={1}>
                    <LoginForm
                      onSubmitSuccess={handleSubmitSuccess}
                      handleDoisFatores={handleDoisFatores}
                    />
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mt={3}
                  >
                    <Link
                      href="https://www.cigam.com.br"
                      target="_blank"
                      underline="hover"
                    >
                      <img
                        alt="Desenvolvido por CIGAM"
                        src="/static/images/powered-cigam.png"
                      />
                    </Link>
                  </Box>
                </CardContent>
              </Card>
            )}
            {open && (
              <AutenticacaoDoisFatores
                telaAtiva={telaAtiva}
                setTelaAtiva={setTelaAtiva}
              />
            )}
          </Container>
        </StyledPage>
      </DoisFatoresProvider>
    </>
  );
};

export default LoginCigam;
